"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UserManageComponent;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _fa = require("react-icons/fa");
var _DataTable = require("@ccw-pwa-ui/DataTable");
var _ai = require("react-icons/ai");
require("./userIndex.css");
var _Button = require("@ccw-pwa-ui/Button");
function UserManageComponent(props) {
  const addUserString = {
    MAIN_CONTENT: /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: "flex"
      }
    }, "Click on", /*#__PURE__*/_react.default.createElement(_Button.Button, {
      variant: "nav-link-button",
      icon: /*#__PURE__*/_react.default.createElement(_fa.FaPlus, null),
      title: props.addEmployeeBtnTitle,
      onClick: props.handleAddEmployee,
      buttonStyle: {
        width: "".concat(props.userInfo.userType === 4 ? "140px" : "150px"),
        marginLeft: "4px",
        marginRight: "4px",
        marginTop: "0px"
      }
    }), "to add ", props.userInfo.userType === 4 ? "an Employee" : "a Technician")
  };
  return /*#__PURE__*/_react.default.createElement("div", null, props.isModalLoading && props.Loader, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variantBtn1: "primary-long",
    customIcon: props.customIcon,
    variantBtn2: "nav-link-button",
    btn2Style: {
      width: '100%',
      justifyContent: "center"
    },
    variant: props.ErrorModalVariant,
    modalHeaderText: props.ErrorModalHeaderText,
    modalHeaderTextStyle: {
      fontSize: 20,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "25px",
      fontFamily: "Poppins"
    },
    modalDetailText: props.ErrorModalDetailText,
    modalDetailText2: props.ErrorModalDetailText2,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      fontFamily: "Poppins"
    },
    displayModal: props.errorModal,
    positiveActionButtonTitle: props.positiveActionErrorButtonTitle,
    negativeButtonActionTitle: props.negativeErrorButtonActionTitle,
    positiveAction: props.handleErrorModal,
    negativeAvtion: props.handleErrorCancelModal
  }), /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variant: props.inviteModalVarient,
    modalHeaderText: props.modalHeaderText,
    modalHeaderTextStyle: {
      fontSize: 20,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "25px",
      fontFamily: "Poppins"
    },
    modalDetailText: props.modalDetailText,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      fontFamily: "Poppins"
    },
    displayModal: props.reInviteModal,
    positiveActionButtonTitle: props.positiveActionButtonTitle,
    negativeButtonActionTitle: props.negativeButtonActionTitle,
    positiveAction: props.handleResendInviteModal,
    negativeAvtion: props.handleSetReInviteCancelModal
  }), props.DeleteModal ? /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variantBtn1: "outline-primary-long",
    variantBtn2: "nav-link-button",
    btn2Style: {
      width: '100%',
      justifyContent: "center"
    },
    btn1Style: {
      color: "#E00932",
      borderColor: "#E00932"
    },
    variant: props.deleteModalVariant,
    modalHeaderText: props.deleteModalHeaderText,
    modalHeaderTextStyle: {
      fontSize: 20,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "25px",
      fontFamily: "Poppins"
    },
    modalDetailText: props.deleteModalDetailText,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      fontFamily: "Poppins"
    },
    displayModal: props.deleteModal,
    positiveActionButtonTitle: props.positiveActionDeleteButtonTitle,
    negativeButtonActionTitle: props.negativeDeleteButtonActionTitle,
    positiveAction: props.handleDeleteModal,
    negativeAvtion: props.handleDeleteCancelModal
  }) : null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingLeft: "50px",
      paddingRight: "50px",
      marginTop: "10px"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-flex-cls addEmployeeBtn-style"
  }, props.subHeading ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Manage ".concat(props.userPersona, "s - ").concat(props.subHeading),
    variant: "header-text",
    headerStyle: {
      fontSize: 27,
      color: '#0B3471',
      fontWeight: 600,
      lineHeight: "34px"
    }
  }) : /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Manage ".concat(props.userPersona),
    variant: "header-text",
    headerStyle: {
      fontSize: 27,
      color: '#0B3471',
      fontWeight: 600,
      lineHeight: "34px"
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    icon: /*#__PURE__*/_react.default.createElement(_fa.FaPlus, null),
    title: props.addEmployeeBtnTitle,
    onClick: props.handleAddEmployee
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-flex-cls m-t-48",
    "data-testid": "checkboxTblChk"
  }, /*#__PURE__*/_react.default.createElement("div", null, props.allSelect || props.rowSelect && props.rowSelect.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col d-flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ml-10-mr-20 click-cursor ",
    "data-testid": "resend-btn-header",
    onClick: props.handleSetReInviteSubmitModal,
    style: {
      ...(props.resendButtonState ? {
        cursor: 'not-allowed'
      } : {
        cursor: 'pointer'
      })
    }
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: /*#__PURE__*/_react.default.createElement(_ai.AiOutlineMail, {
      style: {
        fontSize: 16,
        ...(props.resendButtonState ? {
          color: "#BFC1C4"
        } : {
          color: '#0B3471'
        }),
        fontWeight: 700,
        lineHeight: "24px"
      }
    }),
    variant: "header-text",
    headerStyle: {
      fontSize: 20,
      fontWeight: 200,
      lineHeight: "34px",
      marginRight: "2px"
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: props.headerTextResendInvite,
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      ...(props.resendButtonState ? {
        color: "#BFC1C4"
      } : {
        color: '#0B3471'
      }),
      fontWeight: 700,
      lineHeight: "24px"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "delete-btn-header",
    onClick: props.handleSetDeleteSubmitModal
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: /*#__PURE__*/_react.default.createElement(_ai.AiFillDelete, {
      style: {
        fontSize: 16,
        color: '#E00932',
        fontWeight: 700,
        lineHeight: "24px"
      }
    }),
    variant: "header-text",
    headerStyle: {
      fontSize: 20,
      fontWeight: 200,
      lineHeight: "34px",
      marginRight: "2px"
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Remove ".concat(props.rowSelect.length <= 1 ? "".concat(props.userPersona) : "".concat(props.userPersona, "s")),
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      color: '#E00932',
      fontWeight: 700,
      lineHeight: "24px",
      cursor: 'pointer'
    }
  })))) : /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "You have ".concat(props.totalUsers, " ").concat(props.totalUsers === 1 ? "".concat(props.userInfo.userType === 4 ? "Employee" : "Technician") : "".concat(props.userInfo.userType === 4 ? "Employees" : "Technicians")),
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      color: '#9A9A9A',
      fontWeight: 400,
      lineHeight: "22px"
    }
  })), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "filter-search-box",
    onKeyPress: props.handleOnKeyPress,
    inputProps: {
      placeholder: props.inputPlaceHolder,
      value: props.inputVal,
      onchange: props.setInputVal,
      disabled: props.disabled,
      suffix: /*#__PURE__*/_react.default.createElement(_ai.AiOutlineSearch, {
        "data-testid": "search-icon-suffix",
        style: props.inputVal ? {
          fontSize: 20,
          color: '#333333',
          cursor: "pointer"
        } : {
          fontSize: 16,
          color: '#9A9A9A'
        },
        onClick: props.handleSearch
      })
    },
    selectProps: {
      dropdownList: props.dropdownList,
      itemClick: props.handleSetSelectVal,
      selectedItem: props.selectVal.title || "Select",
      placeholder: props.placeholderDropdown
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "m-t-48 DataTableClass"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, {
    checkboxPosition: "left",
    activeRowStyle: {
      background: 'transparent',
      cursor: 'pointer'
    },
    isReponsive: true,
    isHover: true,
    isLoading: props.isLoading,
    allowRowClick: props.allowRowClick,
    handleRowClick: (e, row, j) => props.handleEmployeeRowClick(e, row, j),
    headerSchema: props.headerSchema,
    bodySchema: props.usersList,
    handleAllRowSelected: props.setAllSelected,
    allRowSelected: props.allSelect,
    rowSelectedList: props.rowSelect,
    handleRowSelect: props.setRowSelected,
    userStatusData: props.userStatusData,
    image: props.image,
    statusModalShow: props.statusModalShow,
    statusModalFlag: props.statusModalFlag,
    paginationProps: {
      totalLength: props.totalUsers,
      currentPage: props.currentPage,
      pageSize: props.pageSize,
      handlePageChange: props.handlePageChange,
      paginationStyle: {
        float: "right"
      }
    },
    loadingDataProps: {
      headingTitle: "Loading...",
      headerDesc: "Please wait while we fetch records..."
    },
    noDataProps: {
      headingTitle: "No ".concat(props.userInfo.userType === 4 ? "Employees" : "Technicians", " Added"),
      headerDesc: addUserString.MAIN_CONTENT
    }
  })))), !props.subHeading && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      zIndex: 9999,
      position: "fixed",
      top: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      backdropFilter: "blur(1px)",
      background: "rgba(255,255,255,0.2)"
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })));
}